import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Accordion,
  Table,
  Dropdown,
  Spinner,
} from "react-bootstrap";
import { Link,useHistory} from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
function AllStaff() {
  const history=useHistory()
 // const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState('');
  const [getData, setGetData] = useState([]);
  const [allstaff, setallstaff] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteStaff, setDeleteStaff] = useState(false);
  const [updatePass, setUpdatePass] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [name, setName] = useState("");
  const [phno, setphon] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [role, setrole] = useState("");
  const [id, setid] = useState("");
  const [spinner, setSpinner] = useState(true);
  function getStaffData() {
    axios.get(`${Baseurl.baseurl}/staff/get-all-staff`).then((response) => {
      setSpinner(false);

      setallstaff(response.data.details);
      setData(document.querySelectorAll("#job_data tbody tr"))
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })

    axios.get(`${Baseurl.baseurl}/roles/get-roles`).then((response) => {
      setGetData(response.data.details);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getStaffData();
  }, []);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function deleteStaffById() {
    handleClose();
    var config = {
      method: "delete",
      url: `${Baseurl.baseurl}/staff/delete-staff-by-id/${id}`,
      headers: {},
    };

    axios(config)
      .then(function(response) {
        swal("Staff Deleted", response.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
        getStaffData();
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
    })
  }
  const deleteHandlevehicletype = (update111, id, name, phone, email, role) => {
    setDeleteStaff(false);
    setUpdatePass(false);
    if (update111 == "update") {
      handleShow();
      setName(name);
      setphon(phone);
      setemail(email);
      setrole(role);
      setid(id);
    }
  };
  const getallstaff = () => {
    axios
      .get(`${Baseurl.baseurl}/roles/get-roles`, { withCredentials: true })
      .then((response) => {
        setGetData(response.data.details);
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
    })
  };
  const submitHandler = (e) => {
    e.preventDefault();
    const artical = {
      Name: name,
      Email: email,
      Role: role,
      Phone: phno,
    };
    axios
      .put(`${Baseurl.baseurl}/staff/update-staff/${id}`, artical)
      .then(
        (response) =>
        
          swal("Staff Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          }),
        handleClose(),
        getStaffData(),
        getallstaff()
      )
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };
  function changePassword(e) {
    e.preventDefault();
    const artical = {
      Password: password,
    };
    axios
      .put(`${Baseurl.baseurl}/staff/update-staff-password/${id}`, artical)
      .then((response) => {
        if (response.data.status)
        
        {
           swal("Password Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          })
            handleClose()
            getStaffData()
            getallstaff()
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
    })
  }
  


 
  return (
    <Col lg={12}>
      <Modal show={show} onHide={handleClose}>
        {/* <Modal.Header closeButton>
                    <Modal.Title>Staff Update</Modal.Title>
                </Modal.Header> */}
        <Modal.Body>
          {updatePass ? (
            <form
              onSubmit={(e) => {
                changePassword(e);
              }}
            >
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Change Password
                </label>
                <div className="col-sm-5">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Change Password"
                    minLength={6}
                    onChange={(e) => setpassword(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group row">
                  <input
                    className="btn btn-primary ml-4"
                    type="submit"
                    value="submit"
                  />
                </div>
              </div>
            </form>
          ) : (
            <>
              {deleteStaff ? (
                <h4>are you sure! want to delete staff</h4>
              ) : (
                <form onSubmit={(e) => submitHandler(e)}>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-9">
                      <input
                        defaultValue={name}
                        type="text"
                        className="form-control"
                        placeholder="name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Phone no.</label>
                    <div className="col-sm-9">
                      <input
                        defaultValue={phno}
                        type="phone"
                        className="form-control"
                        placeholder="Phone no."
                        onChange={(e) => setphon(e.target.value)}
                        required
                        maxLength={10}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        defaultValue={email}
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        onChange={(e) => setemail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-8">
                      <label>Select Role:</label>
                      <select
                        defaultValue={role}
                        className="form-control"
                        id="sel1"
                        onChange={(e) => setrole(e.target.value)}
                        required
                      >
                        
                        {getData.map((d, i) => (
                          <option value={d.Title}>{d.Title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-2 mt-4">
                      <button className="btn btn-primary">Submit</button>
                    </div>
                  </div>
                </form>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {deleteStaff && (
            <Button
              variant="primary"
              onClick={() => {
                deleteStaffById();
              }}
            >
              Yes
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Card style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
        <Card.Header>
          <Card.Title className="text-white">All Staff</Card.Title>
          <div>
            <Link to="./new-staff">
              <button className="btn btn-primary ">Add New Staff</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
    
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive className="table text-white">
                <thead>
                  <tr>
                    <th>
                      <strong>Slno.</strong>
                    </th>
                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>Phone No.</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Role</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allstaff.map((i, key) => (
                    <tr>
                      <td>{key + 1}</td>
                      <td>{i.Name}</td>
                      <td>{i.Phone}</td>
                      <td>{i.Email}</td>
                      <td>{i.Role}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="warning"
                            className="light sharp i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>{" "}
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                deleteHandlevehicletype(
                                  "update",
                                  i._id,
                                  i.Name,
                                  i.Phone,
                                  i.Email,
                                  i.Role
                                );
                              }}
                            >
                              Update
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setid(i._id);
                                setShow(true);
                                setUpdatePass(true);
                                setDeleteStaff(false);
                              }}
                            >
                              Update Password
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setid(i._id);
                                setUpdatePass(false);
                                setDeleteStaff(true);
                                setShow(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default AllStaff;
